module.exports = "https://www.gc-pro.gnp.com.mx/bfc451188332cdbf413aafa403207452.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-lista.svg
// module id = 8126
// module chunks = 0